import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import {
  AuthenticationService,
  ApplicationApiService
} from '../../data-services/index';

import {
  IApplication, IApplicationInput, IUser, IOptions, IApprovalTask
} from '@ebb-v2/ebb-integration';
import { timeout } from 'rxjs/operators';
import { AbstractControl } from '@angular/forms';

@Component({
    selector: 'ebb-portal-permit-form',
    templateUrl: './permit-form.component.html',
    styles: [],
    standalone: false
})
export class PermitFormComponent implements OnInit  {
  @Input('application') application: IApplication;
  @Input('task') taskBuildingPermit: IApprovalTask;
  @Input('permitPlanTypeOptions') permitPlanTypeOptions: IOptions[];
  @Input('saveButtonLabel') saveButtonLabel: string;
  @Input('isDisabled') isDisabled: boolean;
  @Output() emitPermitInfoChangeEvent = new EventEmitter<IApplicationInput>();
  public filteredPermitPlanTypeOptions: IOptions[] = [];
  public currentUser: IUser;

  public formPermitInfo: FormGroup;
  public formAutoSavePermit = false;
  public homeownerPaidForPermit = false;
  public isSgQualify = false;
  constructor(
    private fb: FormBuilder,
    private readonly authenticationService: AuthenticationService,
    private apiApplication: ApplicationApiService
  ) {}

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
    this.isSgQualify = this.application.sGStatus === 700000004;
    this.initializeForms();
    this.loadPermitInfoForm();
    
  }

  private initializeForms(): void {
this.formPermitInfo = this.fb.group({
  permitIssuer: ['', Validators.required],
  permitIssuedDate: ['', Validators.required],
  permitPlanType: ['', Validators.required],
  permitNumber: ['', Validators.required],
});
  }
  public isEMR(): boolean {
    return this.application.programType === 700000004;
  }
  private loadPermitInfoForm(): void {
//filter permit plan options based on Program Type
if(this.application.programType === 700000003)  {
  this.filteredPermitPlanTypeOptions.push(this.permitPlanTypeOptions[4]);
  this.filteredPermitPlanTypeOptions.push(this.permitPlanTypeOptions[5]);
}
else if(this.application.programType === 700000000)  {
  this.filteredPermitPlanTypeOptions.push(this.permitPlanTypeOptions[0]);
  this.filteredPermitPlanTypeOptions.push(this.permitPlanTypeOptions[1]);
  this.filteredPermitPlanTypeOptions.push(this.permitPlanTypeOptions[2]);
  this.filteredPermitPlanTypeOptions.push(this.permitPlanTypeOptions[3]);
}
else if(this.application.programType === 700000004)  {
  this.filteredPermitPlanTypeOptions.push(this.permitPlanTypeOptions[5]);
}
else {
  this.filteredPermitPlanTypeOptions.push(this.permitPlanTypeOptions[0]);
  this.filteredPermitPlanTypeOptions.push(this.permitPlanTypeOptions[1]);
  this.filteredPermitPlanTypeOptions.push(this.permitPlanTypeOptions[2]);
  this.filteredPermitPlanTypeOptions.push(this.permitPlanTypeOptions[3]);
  this.filteredPermitPlanTypeOptions.push(this.permitPlanTypeOptions[4]);
}

    if (
      this.application.permitIssuer &&
      this.application.permitIssuer.length > 0
    )
      this.formPermitInfo
        .get('permitIssuer')
        .setValue(this.application.permitIssuer);

    const permitDateUTC = new Date(this.application.permitIssuedDate);
    permitDateUTC.setHours(permitDateUTC.getHours() + 8);
    const permitDatePST = new Date(permitDateUTC);
    const permitIssuedDate: Date = new Date(permitDatePST);

    if (this.application.permitIssuedDate)
      this.formPermitInfo.get('permitIssuedDate').setValue(permitIssuedDate);

    if (
      this.application.permitPlanCode &&
      this.application.permitPlanCode >= 700000000
    )
      this.formPermitInfo
      .get('permitPlanType')
      .setValue(this.application.permitPlanCode);      
    if (
      this.application.permitNumber &&
      this.application.permitNumber.length > 0
    )
      this.formPermitInfo
        .get('permitNumber')
        .setValue(this.application.permitNumber);

   

  
    if (this.checkPermitFormLock()) {
      this.formPermitInfo.get('permitIssuer').disable();
      this.formPermitInfo.get('permitIssuedDate').disable();
      this.formPermitInfo.get('permitPlanType').disable();
      this.formPermitInfo.get('permitNumber').disable();
     
    }


  }

 

  public checkPermitFormLock(): boolean {
    //override by parent
    //i.e SG and W-9 & Build Permit already completed w/n rejected
    if(this.isDisabled)  {
      return true;
    }

    let retVal = false;
    if (
      (this.application.stageCode === 700000000 &&
        this.application.eventPreliminaryReview === true &&
        (this.taskBuildingPermit.statusCode &&
          this.taskBuildingPermit.statusCode !== 700000002 && this.application.submissionRejection !== 700000001)) ||
      this.application.eventMitigationReviewSubmitted ||
      this.application.eventFinancialReviewSubmitted ||
      (this.isContractor() &&
        this.application.contractorPermissionsCode === 700000003) ||
      this.application.stageCode === 700000001
    ) {
      retVal = true;
    }
    return retVal;
  }

  public onCheckPermitControlValidators(controlName: string): boolean {

    const retVal =
      this.formPermitInfo.get(controlName).errors &&
      (this.formPermitInfo.get(controlName).dirty ||
        this.formPermitInfo.get(controlName).touched);
    return retVal;
  }

  public onClickSavePermitInfo(): void {
    const applicationInput: IApplicationInput = {} as IApplicationInput;
    this.formAutoSavePermit = true;
    applicationInput.permitIssuer = this.formPermitInfo.get(
      'permitIssuer'
    ).value;
    applicationInput.permitIssuedDate = this.formPermitInfo.get(
      'permitIssuedDate'
    ).value;
    applicationInput.permitPlanCode = parseInt(
      this.formPermitInfo.get('permitPlanType').value,
      10
    );
    applicationInput.permitNumber = this.formPermitInfo.get(
      'permitNumber'
    ).value;
   
    
    this.apiApplication
      .updateApplication(applicationInput, this.application.id)
      .subscribe(
        () => {
          this.emitPermitInfoChangeEvent.emit(applicationInput);
          this.formAutoSavePermit = false;
          this.formPermitInfo.markAsPristine();
        },
        error => {
          console.warn(`ERROR: onClickSavePermitInfo() - ${error}`);
          this.formAutoSavePermit = false;
        }
      );
  }

  public setCostToZeroIfEmpty(event) {
    if (
      event.target.value === '' ||
      event.target.value <= 0 ||
      event.target.value < 0.01
    ) {
      event.target.value = 0;
    }
  }



  private formatBool(input: any): boolean {
    if (input === '1' || input === 1 || input === 'true' || input === true) {
      return true;
    }

    return false;
  }

  private formatCur(input: any): number | any {
    if (input) {
      return input;
    }

    return 0;
  }

  /***     User Convenience Methods */
  public isHomeowner() : boolean {
    return this.authenticationService.isHomeowner(this.currentUser);
  }

  public isContractor(): boolean {
    return this.authenticationService.isContractor(this.currentUser);
  }
}
